import PORSiteToSiteConfiguration from "../../entities/PORSiteToSiteConfiguration";
import PORSiteToSiteStandardConfiguration from "../../entities/PORSiteToSiteStandardConfiguration";

export default class UpdateOnPremS2SRequest {
    type: string;
    approver: string;
    option: number;
    companyName!: string;
    exxonConfiguration!: PORSiteToSiteConfiguration;
    externalConfiguration!: PORSiteToSiteConfiguration;
    standardConfiguration!: PORSiteToSiteStandardConfiguration;
    exxonEncrypDomain!: string;
    externalEncrypDomain!: string;
    conDeviceCount!: string;

    constructor(obj: any) {
        Object.assign(this, obj);
        if (obj.exxonConfiguration) this.exxonConfiguration = new PORSiteToSiteConfiguration(obj.exxonConfiguration);
        if (obj.externalConfiguration) this.externalConfiguration = new PORSiteToSiteConfiguration(obj.externalConfiguration);
        if (obj.standardConfiguration) this.standardConfiguration = new PORSiteToSiteStandardConfiguration(obj.standardConfiguration);
    }
}